// OTO-020: shared load-timeout constants for piano sample loading (usePianoAudio) and
// notation rendering (NotationDisplay). Both watch for the deployed env's Cloudflare-fronted
// latency, so a single value covers both -- kept as two named exports (not one shared const)
// so each caller's intent stays self-documenting at the import site.

export const PIANO_LOAD_TIMEOUT_MS = 60_000;
export const NOTATION_LOAD_TIMEOUT_MS = 60_000;
